import { useMemo } from "react";

import { useAppSelector } from "stores";

export const useOwner = ({ empId }: { empId: number }) => {
  const currentEmpId =
    useAppSelector((state) => state?.auth.currentOrganization?.employeeId) || 0;

  const isOwner = useMemo(() => {
    return currentEmpId === empId;
  }, [currentEmpId, empId]);
  return isOwner;
};
